import { DocketEntryTypeNotificationsState } from './partials/notifications'

export const DocketEntryTypeState = _ => ({
  ...DocketEntryTypeNotificationsState,

  docketEntryTypes: [],
})
